import React from "react";

// Functions
import m from "../../../functions/m";
import validate from "../../../functions/validate";
import errors from "../../../functions/errors";

class Input extends React.Component {
	constructor(props) {
		super(props);
		this._onFocus = this._onFocus.bind(this);
		this._onBlur = this._onBlur.bind(this);
		this._onChange = this._onChange.bind(this);
		this._onKeyDown = this._onKeyDown.bind(this);
		this._onLabelClick = this._onLabelClick.bind(this);

		this.state = {
			focus: false,
			value: this.props.value || "",
			error: errors(this.props.errors, this.props.id) || ""
		};
	}

	componentWillReceiveProps(nextProps) {
		var setValue = false;
		var setError = false;

		if (nextProps.value !== undefined && nextProps.value !== this.props.value) setValue = nextProps.value;

		if (nextProps.validate && nextProps.validation !== undefined && Array.isArray(nextProps.validation))
			setError = validate(nextProps.validation, this.state.value) || "";

		if (nextProps.errors !== undefined && nextProps.errors.length > 0)
			setError = errors(nextProps.errors, nextProps.id) || setError;

		if (setValue !== false && setError !== false) this.setState({ value: setValue, error: setError });
		else if (setValue !== false) this.setState({ value: setValue });
		else if (setError !== false) this.setState({ error: setError });
	}

	_onFocus() {
		this.setState({ focus: true });
		if (this.props.onFocus !== undefined) this.props.onFocus();
	}

	_onBlur(event) {
		var value = event.currentTarget.value;
		var error =
			this.props.validation !== undefined && Array.isArray(this.props.validation)
				? validate(this.props.validation, value)
				: "";

		this.setState({ focus: false, error: error });
		if (this.props.onBlur !== undefined) this.props.onBlur(this.props.field, this.props.location, value);
	}

	_onChange(event) {
		var value = event.currentTarget.value;
		var error =
			this.props.validation !== undefined && Array.isArray(this.props.validation) && this.state.error !== ""
				? validate(this.props.validation, value)
				: "";

		this.setState({ value: value, error: error });
		if (this.props.updateFn !== undefined) this.props.updateFn(this.props.field, this.props.location, value);
	}

	_onKeyDown(event) {
		if (this.props.keyDown === undefined) {
			var code = event.keyCode ? event.keyCode : event.which;
			if (code === 13 && this.props.onReturn !== undefined)
				this.props.onReturn(this.props.field, this.props.location, event.currentTarget.value, true);
			else if ((code === 8 || code === 46) && this.state.value === "" && this.props.onBack !== undefined)
				this.props.onBack(this.props.field, this.props.location, event.currentTarget.value);
		} else this.props.keyDown(event);
	}

	_onLabelClick() {
		if (!this.state.focus && this.state.value === "" && this.props.id !== undefined)
			document.getElementById(this.props.id).focus();
	}

	render() {
		const primaryStyle = {
			width: "100%",
			display: "inline-block",
			fontSize: "16px",
			//height: "56px",
			position: "relative",
			textAlign: "left"
		};

		var labelColor = this.props.dark ? "rgba(255, 255, 255, 0.54)" : "rgba(0, 0, 0, 0.54)";
		if (this.state.error !== "") labelColor = "red";
		else if (this.state.focus || this.state.value)
			labelColor = this.props.dark ? "rgba(255, 255, 255, 0.38)" : "rgba(0, 0, 0, 0.38)";

		const labelStyle = {
			fontSize: this.state.focus || this.state.value !== "" ? "12px" : "16px",
			color: labelColor,
			position: "absolute",
			transition: "0.2s all ease",
			left: "16px",
			top: this.state.focus || this.state.value !== "" ? "8px" : "20px",
			fontWeight: "400"
		};

		const underlineColor = this.props.noLine
			? "linear-gradient(rgb(70, 180, 175),rgb(70, 180, 175)),linear-gradient(transparent,transparent)"
			: "linear-gradient(rgb(70, 180, 175),rgb(70, 180, 175)),linear-gradient(#D2D2D2,#D2D2D2)";

		const padding = this.props.padding || "28px 16px 8px";

		const inputStyle = {
			padding: this.props.thin ? "8px 16px" : padding,
			borderRadius: "4px",
			border: "none",
			fontSize: "16px",
			lineHeight: "24px",
			color: this.props.dark ? "rgba(255, 255, 255, 0.87)" : "rgba(0, 0, 0, 0.87)",
			fontFamily: "Roboto",
			fontWeight: "400",
			outline: "0",
			width: "calc(100% - 32px)",
			backgroundColor: this.props.colored ? "rgba(0, 0, 0, 0.06)" : "transparent",
			backgroundImage: this.props.noInputClass
				? ""
				: this.state.error !== ""
				? "linear-gradient(red,red),linear-gradient(#D2D2D2,#D2D2D2)"
				: underlineColor
		};

		if (this.props.inputStyle) {
			var styleKeys = Object.keys(this.props.inputStyle);
			styleKeys.forEach(myKey => {
				inputStyle[myKey] = this.props.inputStyle[myKey];
			});
		}

		const underStyle = {
			display: "inline-block",
			fontSize: "12px",
			marginTop: "8px",
			marginLeft: "16px",
			color: this.state.error === "" ? "rgba(0, 0, 0, 0.54)" : "red",
			fontWeight: "400",
			transition: "0.2s all ease",
			opacity: this.state.error === "" && this.props.helpText === undefined ? "0" : "1"
		};

		return (
			<div style={m(primaryStyle, this)}>
				{this.props.label ? (
					<span style={labelStyle} onClick={this._onLabelClick}>
						{this.props.label}
					</span>
				) : (
					""
				)}
				<input
					ref={this.textInput}
					id={this.props.id}
					style={inputStyle}
					type={this.props.type || "text"}
					onFocus={this._onFocus}
					onBlur={this._onBlur}
					onChange={this._onChange}
					value={this.state.value}
					onKeyDown={this._onKeyDown}
					placeholder={this.props.placeholder || ""}
					className={this.props.noInputClass ? "" : "mui-underline"}
					readOnly={this.props.readOnly || false}
					min={this.props.min}
					max={this.props.max}
					autoComplete="off"
				/>
				{!this.props.noHelp && !this.props.thin ? (
					<div style={underStyle}>
						{this.state.error === "" && this.props.helpText ? this.props.helpText : this.state.error}
					</div>
				) : (
					""
				)}
			</div>
		);
	}
}

export default Input;
